import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

@Directive({
  selector: '[siaMatContextMenu]',
  standalone: true,
})
export class SiaMatContextMenuDirective {
  @Input() matMenuTrigger!: MatMenuTrigger | any;

  constructor(private element: ElementRef) {}

  @HostListener('contextmenu', ['$event'])
  onScroll(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.matMenuTrigger.openMenu();
    this.matMenuTrigger._element.nativeElement.style.position = 'fixed';
    this.matMenuTrigger._element.nativeElement.style.top = event.clientY + 'px';
    this.matMenuTrigger._element.nativeElement.style.left =
      event.clientX + 'px';
  }
}
